<template>
  <div class="product-review-carousel">
    <!-- TrustBox widget - Product Carousel -->
    <div
      :id="id"
      class="trustpilot-widget"
      :data-locale="clientModel.trustPilotSettings.trustPilotLocale"
      :data-review-languages="clientModel.trustPilotSettings.trustPilotDataReviewLanguage"
      data-template-id="60f537b5b0f1639de1fe048c"
      :data-businessunit-id="clientModel.trustPilotSettings.trustPilotBUnitId"
      data-style-height="140px"
      data-style-width="100%"
      :data-sku="sku"
      data-no-reviews="hide"
      :data-third-party-reviews="clientModel.trustPilotSettings.trustPilotIncludeImportedReviews">
      <a :href="clientModel.trustPilotSettings.trustPilotFallbackLink" target="_blank" rel="noopener">Trustpilot</a>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    sku: {
      type: String,
      required: true
    }
  },
  data: () => ({
    id: ''
  }),
  async mounted() {
    this.id = _.uniqueId('product-review-carousel-')
    await this.$nextTick()
    if (window.Trustpilot) {
      const widget = document.getElementById(this.id)
      window.Trustpilot.loadFromElement(widget)
    }
  }
}
</script>
